import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CardDetailsModal } from "@components/ui/CardDetailsModal";

const SleepOpenCards = ({ stepsData = [] }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(false);
  const handleOpen = ({
    label = null,
    icon = null,
    value = null,
    tabColor = null,
    model_value = null,
  }) => {
    setData({
      label,
      icon,
      value,
      tabColor,
      model_value,
    });
    setOpen(true);
  };

  // Card component for reusability
  const Card = ({
    label,
    icon,
    value,
    tabColor,
    model_value,
    bg,
    t,
    padding = "md:pt-[130px] md:pb-10 xl:p-0",
  }) => (
    <div
      className="
    pb-3
    px-[25%]
    [@media(min-width:400px) and (max-width:450px)]:px-[28%]
    [@media(max-width:549px)]:px-[32%]
    [@media(min-width:550px) and (max-width:767px)]:px-[38%]
    md:px-[23%]

    xl:px-8
    xl:pt-[62%]
    [@media(min-width:1680px)]:pt-[50%]

    2xl:px-12

    [@media(min-width:1281px)]:!min-h-[250px]
    [@media(min-width:1400px)]:!min-h-[270px]
    [@media(min-width:1530px)]:!min-h-[300px]

    cursor-pointer transition-all duration-200
    hover:scale-105 rounded-[17px] overflow-hidden
    w-full bg-contain
  "
      style={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
      onClick={() => handleOpen({ label, icon, value, tabColor, model_value })}
    >
      <div className={`mindfulness-content ${padding}`}>
        <p
          className="text-[14px] font-[500] text-[#6C6A6A] font-[Lato] text-center truncate"
          title={label}
        >
          {label}
        </p>
        <div className="sleep-text-container">
          <p
            className="text-[12px]  font-[500] font-[Lato] text-[#898787] text-center"
            style={{
              wordBreak: "break-word",
              hyphens: "auto",
              overflowWrap: "break-word",
            }}
          >
            {value}...
          </p>
          <span className="cursor-pointer  text-[12px] text-[#15AAFC] font-[Lato] font-[500] block text-center">
            {t("SEE MORE")}
          </span>
        </div>
      </div>
    </div>
  );

  // Split data for different screen sizes
  const firstRowCards = stepsData.slice(0, 3);
  const secondRowCards = stepsData.slice(3, 5);

  // Original layout (non-dashboard)
  return (
    <div className="p-6 bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-lg mt-6">
      <p className="text-[14px] font-[Lato] text-white pb-4 text-center"> {t("Tap a mini card")}</p>
      {/* First Row - 3 cards on mobile/tablet, all cards in one row on desktop */}
      <div className="hidden [@media(min-width:768px)]:block xl:!hidden">
        {/* First row - 3 cards */}
        <div className="!grid !grid-cols-1 [@media(min-width:550px)]:!grid-cols-3 gap-4 mb-4">
          {firstRowCards.map(
            ({ label, icon, value, tabColor, model_value, bg }, index) => (
              <Card
                key={index}
                label={label}
                icon={icon}
                value={value}
                tabColor={tabColor}
                model_value={model_value}
                t={t}
                bg={bg}
              />
            )
          )}
        </div>

        {/* Second row - 2 cards centered */}
        {secondRowCards.length > 0 && (
          <div className="flex justify-center gap-4">
            {secondRowCards.map(
              ({ label, icon, value, tabColor, model_value, bg }, index) => (
                <div key={index + 3} className="w-1/3 max-w-[200px]">
                  <Card
                    label={label}
                    icon={icon}
                    value={value}
                    tabColor={tabColor}
                    model_value={model_value}
                    t={t}
                    bg={bg}
                    padding="md:pt-[120px] md:pb-8 xl:p-0"
                  />
                </div>
              )
            )}
          </div>
        )}
      </div>

      {/* Desktop layout - all cards in one row */}
      <div
        className="
    grid grid-cols-1
    min-[768px]:hidden
    xl:grid xl:grid-cols-5
    gap-4
  "
      >
        {stepsData.map(
          ({ label, icon, value, tabColor, model_value, bg }, index) => (
            <Card
              key={index}
              label={label}
              icon={icon}
              value={value}
              tabColor={tabColor}
              model_value={model_value}
              t={t}
              bg={bg}
              padding="pt-[110px] pb-10 md:p-0"
            />
          )
        )}
      </div>

      <CardDetailsModal open={open} setOpen={setOpen} data={data} />
    </div>
  );
};

export default SleepOpenCards;
